import { DensitySmall, StorageOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import IconButton from 'components/icon-button'
import { IProjectOuputTableDTO } from 'data/dtos/automation/i-project-dto'
import { useHistory } from 'react-router-dom'
import { dayjs } from 'utils/custom-date'
import ChipStatus from 'utils/project/chip-status'
import validateOutputTableStatus from 'utils/project/validate-output-table-status'
import { useStyles } from './styles'

interface ProjectTablesViewProps {
  projectId: string
  tables: IProjectOuputTableDTO[]
  organizationId: string
}

const ProjectTablesView = ({ projectId, tables, organizationId }: ProjectTablesViewProps) => {
  const classes = useStyles()
  const history = useHistory()

  const handleFormatDate = (date: string | Date) => dayjs(date).format('DD/MM/YYYY - HH:mm:ss')

  const handleNavigationToTable = (table: IProjectOuputTableDTO) =>
    history.push(`/projects/table/${projectId}/${table.id}/${organizationId}`)

  return (
    <Box className={classes.root}>
      <Box className={classes.headerLine}>
        <div className={classes.headerTitle}>
          <StorageOutlined
            fontSize='medium'
            sx={{ opacity: 0.8 }}
          />
          <h1>Tabelas de saída</h1>
        </div>
      </Box>

      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableNameSize}>Nome</th>
            <th className={classes.tableOthersSize}>Data de criação</th>
            <th className={classes.tableOthersSize}>Registros</th>
            <th className={classes.tableOthersSize}>Status</th>
            <th className={classes.tableActionSize}></th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          {tables.length === 0 && (
            <tr key={Math.random()}>
              <td className={classes.tableNameSize}>
                <span> - </span>
              </td>

              <td className={classes.tableOthersSize}>
                <span> - </span>
              </td>

              <td className={classes.tableOthersSize}>
                <span>0</span>
              </td>

              <td className={classes.tableOthersSize}>
                <ChipStatus text={'Em Espera'} />
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={DensitySmall}
                  isDisabled
                  onClick={() => {}}
                  tooltip='Ver Tabelas'
                />
              </td>
            </tr>
          )}

          {tables.map((table) => (
            <tr key={table.id}>
              <td className={classes.tableNameSize}>
                <span>{table.name}</span>
              </td>

              <td className={classes.tableOthersSize}>
                <span>{handleFormatDate(table?.lastExecution) ?? '-'}</span>
              </td>

              <td className={classes.tableOthersSize}>
                <span>{table.records ? table.records : '-'}</span>
              </td>

              <td className={classes.tableOthersSize}>
                <ChipStatus text={table.status} />
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={DensitySmall}
                  // isDisabled={!table.isAbleToView}
                  isDisabled={validateOutputTableStatus(table.status)}
                  onClick={() => handleNavigationToTable(table)}
                  tooltip='Ver Tabelas'
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}

// const ProjectTablesView: React.FC<ProjectTablesViewProps> = ({ project }) => {
//   const classes = useStyles()
//   const history = useHistory()

//   const tables = project.definitions.tables

//   const handleFormatDate = (date: string | Date) => dayjs(date).format('DD/MM/YYYY - HH:mm:ss')

//   const handleNavigationToTable = (table: ITable) => {
//     if (table.isAbleToView) {
//       history.push(`/projects/table/${project.id}/${table.name}`)
//     }
//   }

//   return (
//     <Box className={classes.root}>
//       <h1 className={classes.title}>Tabelas</h1>
//       <table className={classes.baseContainer}>
//         <tbody className={classes.itemContainer}>
//           {tables.map((table, index: number) => {
//             return (
//               <Paper key={Math.random()} className={classes.paperBox} elevation={2}>
//                 <tr className={classes.item}>
//                   <td className={classes.itemIcon}>
//                     <StorageOutlined fontSize='medium' sx={{ opacity: 0.8 }} />
//                   </td>

//                   <td className={classes.itemHeader}>
//                     <span className={classes.tableLable}>Nome da tabela</span>
//                     <span>{table.label}</span>
//                   </td>

//                   <td className={classes.itemDate}>
//                     {table.updatedAt && (
//                       <>
//                         <span className={classes.tableLable}>Data de upload</span>
//                         <span>{handleFormatDate(table.updatedAt)}</span>
//                       </>
//                     )}
//                   </td>

//                   <td className={classes.itemStatus}>
//                     <span className={classes.tableLable}>Status</span>
//                     <ChipStatus text={table.status} />
//                   </td>

//                   <td className={classes.itemRegister}>
//                     <span className={classes.tableLable}>Registro</span>
//                     <span>{table.registered}</span>
//                   </td>

//                   <td className={classes.itemFooter}>
//                     <IconButton
//                       icon={DensitySmall}
//                       isDisabled={!table.isAbleToView}
//                       onClick={() => handleNavigationToTable(table)}
//                       tooltip='Ver Tabelas'
//                     />
//                   </td>
//                 </tr>
//               </Paper>
//             )
//           })}
//         </tbody>
//       </table>
//     </Box>
//   )
// }

export default ProjectTablesView
